import { makeAutoObservable } from 'mobx';

class ShiftStore {
  shiftDetails: any = {};

  constructor() {
    makeAutoObservable(this);
  }
  setDetails(details: any) {
    this.shiftDetails = details;
  }
}

const shiftStore = new ShiftStore();
export default shiftStore;
